import React, { useEffect } from "react"
import { view } from "@risingstack/react-easy-state"
import { useParams, Redirect, useHistory } from "react-router-dom"
import { message, Button } from "antd"

import StyledBox from "components/common/styled-components/StyledBox"
import StyledPageContent from "components/common/styled-components/StyledPageContent"
import CriteriaSet from "components/CriteriaSet"
import TemplateEditor from "components/TemplateEditor"
import { staleWhileRevalidate } from "utils/render-strategies"
import globalStore from "store/index"
import LetterTemplatesService from "services/users/letter-templates.service"

const AdditionalLetterTemplatesShowPage = () => {
  const pageState = globalStore.ui.configuration.letterTemplates.show
  const history = useHistory()
  const { letterTemplateId } = useParams()
  // const [deleteLoading, setDeleteLoading] = useState(false)
  // const deleteLoading = false

  useEffect(() => {
    const fetchData = async () => {
      const pageState = globalStore.ui.configuration.letterTemplates.show

      await LetterTemplatesService.show({
        pageState,
        letterTemplateId,
      })

      const { serverStatus, letterTemplateErrors } = pageState

      if (serverStatus.status !== 200) {
        message.error("Oops!! something went wrong")
        return
      }

      if (letterTemplateErrors) {
        message.error(
          letterTemplateErrors[0] ||
            "Letter Template couldn't be fetched."
        )
        return
      }
    }

    fetchData()
  }, [letterTemplateId])

  const handleEdit = () => {
    history.push(
      `/configuration/additional-letter-templates/${letterTemplateId}/edit`
    )
  }



  const {
    letter_template,
    API_USERS_LETTER_TEMPLATES_SHOW_STATUS,
  } = pageState

  const renderContent = () => {
    if (!letter_template) return null

    const { criteria, content } = letter_template
    return (
      <div>
        <CriteriaSet criteria={criteria} />
        <div className="input-box">
          <strong>Template</strong>
          <TemplateEditor content={content} editable={false} />
        </div>
      </div>
    )
  }

  const renderPageContent = () => {
    return (
      <StyledPageContent>
        <div className="page-header">
          <h1>{letter_template.name}</h1>
          <div className="action-buttons top">
            <Button type="primary" ghost onClick={handleEdit}>
              Edit
            </Button>
            {/* <Button danger ghost loading={deleteLoading} onClick={handleDelete}>
              Delete
            </Button> */}
          </div>
        </div>

        <div className="content">{renderContent()}</div>
      </StyledPageContent>
    )
  }

  const accessibleFeatures = globalStore.currentUser?.accessible_features || []

  if (accessibleFeatures?.length > 0 && !accessibleFeatures.includes('additional-template-edit'))
		return <Redirect to='/' />

  return (
    <div className="page-content letter-template-page">
      <StyledBox>
        {staleWhileRevalidate({
          status: API_USERS_LETTER_TEMPLATES_SHOW_STATUS,
          data: letter_template,
          render: renderPageContent,
        })}
      </StyledBox>
    </div>
  )
}

export default view(AdditionalLetterTemplatesShowPage)
